module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_inside_04.5ef59c16.png";